export const ktpMy = {
    "老师":"老師",
    "学生":"學生",
    "身份认证":"身份認證",
    "进入机构后台":"進入機構後臺",
    "切换语言":"切換語言",
    "切换中文":"切換中文",
    "切换英文":"切换英文",
    "消息通知":"消息通知",
    "文库":"文庫",
    "账号管理":"賬號管理",
    "VIP管理":"VIP管理",
    "交易记录":"交易記錄",
    "消息设置":"消息設置",
    "机构用户认证":"機構用戶認證",
    "账号":"賬號",
    "微信":"微信",
    "邮箱":"郵箱",
    "手机号":"手機號",
    "密码":"密码",
    "退出登录":"退出登錄",
    "绑定邮箱":"綁定郵箱",
    "请输入图形验证码":"請輸入圖形驗證碼",
    "年":"年",
    "月":"月",
    "超级VIP":"超级VIP",
    "机构VIP":"機構VIP",
    "机构超级VIP":"機構超級VIP",
    "到期":"到期",
    "到期头":"到期頭",
    "所授课程":"所授課程",
    "请输入教授课程名称":"請輸入教授課程名稱",
    "新增课程":"新增課程",
    "上传图片":"上傳圖片",
    "修改失败":"修改失敗",
    "未选择":"未選擇",
    "确定更改入学时间吗":"確定更改入學時間嗎",
    "入学时间修改成功":"入學時間修改成功",
    "手动添加":"手動添加",
    "请输入专业名称":"請輸入專業名稱",
    "高等教育":"高等教育",
    "高职教育":"高職教育",
    "中职教育":"中職教育",
    "请输入正确的专业":"請輸入正確的專業",
    "专业不能为空":"專業不能為空",
    "新增专业":"新增專業",
    "所授专业":"所授專業",
    "所学专业":"所學專業",
    "专业":"專業",
    "当前手机":"當前手機：",
    "未绑定":"未绑定",
    "新手机号":"新手機號",
    "请输入新手机号":"請輸入新手機號",
    "请输入正确的手机号":"請輸入正確的手機號",
    "验证并绑定":"驗證並綁定",
    "请输入上方算式结果":"請輸入上方算式結果",
    "请输入正确的验证码":"請輸入正確的驗證碼",
    "绑定成功":"綁定成功",
    "更换手机号":"更換手機號",
    "绑定手机号":"綁定手機號",
    "解除绑定":"解除綁定",
    "验证并解绑":"驗證並解綁",
    "解除绑定成功":"解除綁定成功",
    "解除绑定失败":"解除绑定失败",
    "已绑定":"已绑定",
    "退出成功":"退出成功",
    "确认登出此账号":"確認登出此賬號?",
    "退出登录将解绑当前的微信号":"退出登錄，將解綁當前的微信號",
    "个":"個",
    "头像":"頭像",
    "教工号":"教工號",
    "身份":"身份",
    "院系":"院系",
    "个人资料":"個人資料",
    "图片正在插入中":"圖片正在插入中...",
    "请选择图片格式的文件":"請選擇圖片格式的文件",
    "图片最大不能超过5MB":"圖片最大不能超過5MB",
    "猜你喜欢":"猜妳喜歡",
    "人阅读":"人閱讀",
    "已认证的机构身份":"已認證的機構身份",
    "点击卡片即可编辑已认证身份":"點擊卡片即可編輯已認證身份",
    "查看机构编排的课程":"查看機構編排的課程",
    "请填写以下信息完成身份认证":"請填寫以下信息完成身份認證",
    "您所在的学校已开通机构后台功能需要完成身份认证才能同步学校为您所排的课程":"您所在的學校已開通機構後臺功能，需要完成身份認證才能同步學校為您所排的課程",
    "学校机构":"學校機構",
    "请输入所在学校机构":"請輸入所在學校機構",
    "请输入学校名称":"請輸入學校名稱",
    "取消绑定":"取消绑定",
    "请输入姓名":"請輸入姓名",
    "请输入学号":"請輸入學號",
    "请输入教工号":"請輸入教工號",
    "以后再说":"以後再說",
    "取消本次认证":"取消本次認證",
    "确认认证":"確認認證",
    "学校已为您进行排课新增排课课程如下您可以选择已经创建的课程绑定排课课程":"學校已為您進行排課，新增排課課程如下，您可以選擇已經創建的課程綁定排課課程。",
    "未被绑定的排课课程将为您自动创建新课程":"未被綁定的排課課程將為您自動創建新課程。",
    "学校已为您进行排课新增排课课程如下您将自动加入以下课程":"學校已為您進行排課，新增排課課程如下，您將自動加入以下課程",
    "认证其他机构":"+ 認證其他機構",
    "选择学校机构":"選擇學校機構",
    "确认自动创建课程":"確認自動創建課程?",
    "有":"有",
    "门排课课程未进行绑定":"門排課課程未進行綁定",
    "系统将自动创建对应课程":"系統將自動創建對應課程",
    "暂不创建":"暫不創建",
    "确认创建":"確認創建",
    "绑定失败":"綁定失敗",
    "认证成功":"認證成功",
    "绑定课程":"綁定課程",
    "暂无课程":"暫無課程",
    "已取消账号绑定":"已取消賬號綁定",
    "可在个人中心处继续完成绑定流程":"可在個人中心處繼續完成綁定流程",
    "发布人":"發布人:",
    "教学活动":"教學活動",
    "教务通知":"教務通知",
    "系统通知":"系統通知",
    "申诉":"申訴",
    "互动试卷":"互動試卷",
    "忽略全部":"忽略全部",
    "消息标题":"消息標題",
    "课堂成员变动":"課堂成員變動",
    "默认周六21:30接收成员变动消息推送":"默認周六21:30接收成員變動消息推送",
    "作业到期":"作業到期",
    "作业到截止日期接收消息通知":"作業到截止日期接收消息通知",
    "课堂私信":"课堂私信",
    "有老师同学私信后接收消息推送":"有老師/同學私信後接收消息推送",
    "话题提醒":"话题提醒",
    "有老师同学发起话题后接收消息推送":"有老師/同學發起話題後接收消息推送",
    "订单编号":"訂單編號：",
    "待支付":"待支付",
    "已退款":"已退款",
    "已关闭":"已關閉",
    "实付款":"實付款",
    "当前状态":"當前狀態",
    "未支付":"未支付",
    "已支付":"已支付",
    "开票状态":"開票狀態",
    "交易类型":"交易類型",
    "订单编号2":"訂單編號",
    "请输入院系":"請輸入院系",
    "请输入正确的":"請輸入正確的",
    "不能为空":"不能为空",
    "当前邮箱":"當前郵箱: ",
    "更换邮箱":"更換郵箱",
    "确认解绑当前已绑定的邮箱吗":"確認解綁當前已綁定的郵箱嗎？",
    "请输入新邮箱":"請輸入新郵箱",
    "新邮箱":"新郵箱",
    "请输入正确的邮箱":"請輸入正確的郵箱",
    "新密码":"新密码",
    "请输入新密码":"請輸入新密碼",
    "请再输入新密码":"請再輸入新密碼",
    "密码修改成功请重新登录":"密碼修改成功，請重新登錄",
    "密码设置":"密碼設置",
    "选择学校名称":"選擇學校名稱",
    "请输入搜索关键词":"請輸入搜索關鍵詞",
    "当前微信":"當前微信：",
    "绑定微信":"綁定微信",
    "长按二维码进行识别绑定":"長按二維碼進行識別綁定",
    "请输入加课码":"請輸入加課碼",
    "进入课堂":"進入課堂",
    "直达课程列表":"直達課程列表",

}
